import { StepHandle } from "..";
import { digitalContentStepService, WorkflowManager } from "../..";
import { DigitalContentStepData, Step, Asset } from "../../types";

/**
 * The digital content step allows for associating uploaded content with a QR code. This code
 * can be displayed on the users design such as in a gift card and people can access
 * the hosted content by scanning the QR.
 */
export class DigitalContentStepHandle extends StepHandle<DigitalContentStepData> {
    constructor(manager: WorkflowManager, step: Step<DigitalContentStepData>, tags: string[]) {
        super(manager, step, tags);
    }

    async selectVariant() {
        //noop
    }

    /**
     * Returns a preview URL used to show the generated QR code in your UI.
     */
    getPreviewURL(): string {
        return this.manager.getStepStorage(this.step.stepName)?.videoUrl || "";
    }

    /**
     * Turns an asset into a QR code that can be used to access the content.
     * @param asset The asset to use for the QR code.
     * @returns The final URL string for the QR code.
     */
    async selectVideo(asset: Asset): Promise<string> {
        return digitalContentStepService.regenerateQRCode(
            this.manager.getRegionElements(this.step.stepName),
            asset.key!,
            this.manager,
            this.step,
        );
    }
}
